import React, { useState } from 'react'
import { Form, Input, message, Spin } from 'antd'
import BlueButton from '../../components/shared/BlueButton';
import { setAccessToken } from '../../helpers/auth/token';
import { login } from '../../api/auth';
import { Link } from 'react-router-dom';
import AuthLayout from './authLayout';

export default function Login() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const { accessToken } = await login(values);
            setAccessToken(accessToken);
            window.location.href = "/";
        } catch (err) {
            message.error("Email or password is incorrect!");
        }
        setLoading(false);
    };

    const onFinishFailed = (errorInfo) => {
        message.error("Something went wrong, please try again later");
    };

    return (
        <AuthLayout className="flex flex-col justify-between">
            <section />

            <section>
                <Form form={form} layout='vertical' onFinish={onFinish}
                    onFinishFailed={onFinishFailed}>
                    <Form.Item name="email" label="Email Address" rules={[{ required: true }]} ><Input type='email' className='rounded-none' /></Form.Item>
                    <Form.Item name="pwd" label="Password" rules={[{ required: true }]} className='p-0 m-0'><Input.Password className='rounded-none' /></Form.Item>
                    <Form.Item className='m-0 p-0 flex justify-end'><Link to='/forgot-password'>Forgot Password?</Link></Form.Item>
                    <Form.Item className='flex justify-center'>
                        <BlueButton type="primary" className="rounded-none min-w-[66.5px]" htmlType="submit" disabled={loading}>
                            {loading ? <Spin size='small' /> : "Login"}
                        </BlueButton>
                    </Form.Item>
                </Form>
            </section>

            <section className='flex flex-col items-center gap-2'>
                <p className='text-center text-[#A0A0A0] font-roboto text-base'>Don&apos;t have an account?</p>
                <Link to="/company-register">Register as a Company</Link>
                <Link to="/user-register">Register as a User</Link>
            </section>

        </AuthLayout>
    )
}
